import { Component, OnInit, OnDestroy, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

import { BehaviorSubject, Subscription } from "rxjs";
import { SignUpNavigationService, Step } from "../services/navigation.service";
import { MatToolbarModule } from "@angular/material/toolbar";
import { AsyncPipe } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatButtonModule } from "@angular/material/button";

const debug = false;

@Component({
  selector: "onsip-signup-entry",
  templateUrl: "./signup-entry.component.html",
  styleUrls: ["./signup-entry.component.scss"],
  imports: [
    MatToolbarModule,
    AsyncPipe,
    TranslateModule,
    MatIcon,
    MatProgressBarModule,
    RouterOutlet,
    MatButtonModule
  ]
})
export class SignUpEntryComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private translate = inject(TranslateService);
  navigate = inject(SignUpNavigationService);

  displayTitle = new BehaviorSubject<string>(""); // translated title
  totalStep = 5;
  currentStepNumber = new BehaviorSubject<number>(1);
  progressBar = new BehaviorSubject<number>(1);
  showBackButton = new BehaviorSubject<boolean>(true);

  private unsubscriber = new Subscription();

  ngOnInit(): void {
    this.router.navigate(["signup"], { skipLocationChange: true });
    this.totalStep = 2;
    this.translate.setDefaultLang("en");
    this.translate.use(this.translate.getBrowserLang() || "en");
    this.initRouterListener();
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }

  navigateBack(): void {
    this.navigate.navigateBackward();
  }

  private initRouterListener(): void {
    this.unsubscriber.add(
      this.router.events.subscribe(() => {
        if (this.router.parseUrl(this.router.url).root.children.primary) {
          let currentTitle: string;
          let currentStep: number;
          let showBackButton = true;
          const currentPage: Step = this.navigate.validateStepName(
            this.router.parseUrl(this.router.url).root.children.primary.segments[1].path
          );
          debug &&
            console.log("EntryComponent: InitRouterListener - Current page from url:", currentPage);

          switch (currentPage) {
            case "signup-domain":
              currentTitle = this.translate.instant("ONSIP_I18N.CREATE_YOUR_DOMAIN_NAME");
              currentStep = 1;
              showBackButton = false;
              break;
            case "signup-profile":
              currentTitle = this.translate.instant("ONSIP_I18N.CREATE_YOUR_PROFILE");
              currentStep = 2;
              break;
            case "signup-topics":
              currentTitle = this.translate.instant("ONSIP_I18N.CONFIGURE_YOUR_DISPLAY");
              currentStep = 3;
              showBackButton = false;
              break;
            // Currently skipping this implementation:
            // case "signup-add-users":
            //   currentTitle = "Invite team members";
            //   currentStep = 4;
            //   break;
            case "signup-cms":
              currentTitle = this.translate.instant("ONSIP_I18N.SELECT_CMS");
              currentStep = 4;
              break;
            case "signup-installation":
              currentTitle = this.translate.instant("ONSIP_I18N.INSTALL_AND_COMPLETE");
              currentStep = 5;
              break;
            default:
              // should be impossible, but helps typing
              currentTitle = this.translate.instant("ONSIP_I18N.CREATE_YOUR_DOMAIN_NAME");
              currentStep = 1;
              showBackButton = false;
          }
          this.displayTitle.next(currentTitle);
          this.currentStepNumber.next(currentStep);
          this.progressBar.next((currentStep / this.totalStep) * 100);
          this.showBackButton.next(showBackButton);
        }
      })
    );
  }
}
